<template>
  <div class="container-fluid springter-section">
    <lang-menu></lang-menu>
    <div class="row">
      <div class="col-12">
        <logo type="regular" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 0})"></logo>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>Make personal <br/>equipment personal</h1>
      </div>
    </div>
    <div class="section-content">
      <div class="row boxes">
        <div class="col-lg-4 col-md-12 col-sm-12 box">
          <p>{{ $t('section2Box1') }}</p>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 box">
          <p>{{ $t('section2Box2') }}</p>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 box">
          <p>{{ $t('section2Box3') }}</p>
        </div>
      </div>
    </div>
    <arrow-button direction="down" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 2})"></arrow-button>
  </div>
</template>

<script>

import Logo from './shared/Logo';
import ArrowButton from './shared/ArrowButton';
import LangMenu from './shared/LangMenu';

export default {
  name: 'springter-section-2',
  components: {
    Logo,
    ArrowButton,
    LangMenu,
  },
};
</script>

<style lang="scss" scoped>
  .springter-section{
    text-align: center;
  }
  button.arrow{
    position: absolute;
    left: 50%;
    margin-left: -17px;
  }

  h1{
    line-height: $lh--small;
    text-align: left;
    padding-left: 12px;

    @include mq('phablet', 'max') {
      margin-top: 10px;
      padding-left: 0;
    }
    @include mqlandscape(){
      margin-top: 10px;
    }
  }
  .boxes {
    @include mq('phablet', 'max') {
      padding-top: 15px;
      padding-bottom: 0px;
    }
    @include mqlandscape(){
      padding-top: 15px;
      padding-bottom: 0px;
    }

    .box {

      p{
        font-size: $p--x-large;
      }

      @include mq('phablet', 'max') {
        border: none;
        margin-bottom: 4%;
        padding-top: 20px;
        padding-bottom: 20px;

        p{
          font-size: $p;
        }
      }

      @include mq('tablet-wide', 'max') {
        p{
          font-size: $p--medium;
        }
      }

      @include mqlandscape(){
        border: none;
        margin-bottom: 5%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/SpringterSection2.vue